import ViewFormativeDialog from 'components/StudentSubmissions/ViewFormativeDialog';
import { useApp } from 'contexts/app';
import { useViewport } from 'contexts/viewport';
import ErrorPage from 'pages/Error/404';
import Desktop from 'pages/InstructorFormativeJourney/desktop';
import Mobile from 'pages/InstructorFormativeJourney/mobile';
import { PageContext } from 'pages/InstructorFormativeJourney/PageProvider';
import Tablet from 'pages/InstructorFormativeJourney/tablet';
import { useContext } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { Loading } from 'shell/components';

const PageLayout = () => {
    const { isLoading, studentAccountUsers, assignments, currentAssignmentId, currentAssignment } = useApp();
    const location = useLocation();
    const { device } = useViewport();

    const contextProps = useContext(PageContext);

    const renderResponsiveLayout = (device) => {
        return {
            mobile: <Mobile {...contextProps} />,
            tablet: <Tablet {...contextProps} />,
            desktop: <Desktop {...contextProps} />,
        }[device];
    };

    const params = new URLSearchParams(location.search);

    if (isLoading || !contextProps.currentStudentSubmissions) return <Loading />;

    if (
        !studentAccountUsers.some(({ owner_account_id }) => owner_account_id === params.get('owner_account_id')) ||
        !contextProps.currentStudentSubmissions.length
    ) {
        const params = new URLSearchParams({ type: 'formative' });
        return <Redirect to={`/assignments/${currentAssignmentId}/submissions?${params.toString()}`} />;
    }

    if (assignments && !currentAssignment) return <ErrorPage />;

    return (
        <>
            {renderResponsiveLayout(device)}
            <ViewFormativeDialog
                dialog={contextProps.viewFormativeDialog}
                onClose={() => {
                    contextProps.setViewFormativeDialog((current) => ({ ...current, open: false }));
                    setTimeout(() => {
                        contextProps.setViewFormativeDialog((current) => ({ ...current, submissionId: '' }));
                    }, 150);
                }}
            />
        </>
    );
};

export default PageLayout;
